"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var satcheljs_1 = require("satcheljs");
var store_1 = require("../store/store");
exports.default = satcheljs_1.mutatorAction('setCategory', function setCategory(categoryKey, subcategoryKey, currentOptionKey) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = store_1.getStore();
            store.currentCategoryKey = categoryKey;
            store.currentSubCategoryKey = subcategoryKey;
            store.currentOptionKey = currentOptionKey;
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=setCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/mutators/setCategory.js
// module id = 5273
// module chunks = 2